import { Input, Popover } from "antd"
import { ReactNode, useState } from "react"
import BaseButton from "../../../components/elements/BaseButton"

type TourRejectPopoverType = {
    onConfirm: (comment: string) => void
    children: ReactNode
}

export default function TourRejectPopover(props: TourRejectPopoverType) {
    const [comment, setComment] = useState("")
    const [open, setOpen] = useState(false)

    const confirm = () => {
        const text = comment.trim()
        if (!text) return
        props.onConfirm(text)
        setComment("")
        setOpen(false)
    }

    return (
        <Popover
            trigger="click"
            open={open}
            onOpenChange={(next) => {
                setOpen(next)
                if (!next) setComment("")
            }}
            placement="bottomLeft"
            title="Ablehnen?"
            content={
                <div className="flex flex-col w-64">
                    <p className="text-sm text-gray-600 mb-2">Begründung ist Pflicht.</p>
                    <Input.TextArea
                        value={comment}
                        onChange={(event) => setComment(event.target.value)}
                        placeholder="Warum wurde die Aufgabe nicht erledigt?"
                        autoSize={{ minRows: 3, maxRows: 5 }}
                    />
                    <div className="flex justify-end mt-2">
                        <BaseButton label="Ablehnen" func={confirm} colorway="warning" size="small" disabled={!comment.trim()} />
                    </div>
                </div>
            }>
            {props.children}
        </Popover>
    )
}
